









































import Vue from 'vue'
import WestWingEnlarged from '@/components/map/static-maps/louis-brier/subcomponents/WestWingEnlarged.vue'
import WestWing from '@/components/map/static-maps/louis-brier/subcomponents/WestWing.vue'
import CenterColumn from '@/components/map/static-maps/louis-brier/subcomponents/CenterColumn.vue'
import EastWing from '@/components/map/static-maps/louis-brier/subcomponents/EastWing.vue'

export default Vue.extend({
  components: { EastWing, CenterColumn, WestWing, WestWingEnlarged },
  props: {
    patientsByRoomNumber: {
      type: Object,
      required: true,
    },
    patients: {
      type: Array,
      required: true,
    },
    // todo, maybe load these from ddb table with a name attr
    sharedRooms: {
      type: Object,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
    mapDisplayOption: {
      type: Object,
      required: true,
    },
  },
})
